import VerifiedRoundedIcon from "@mui/icons-material/VerifiedRounded";
import { Box, Container, Typography } from "@mui/material";

import SmartSearchAnimation from "@assets/images/smart_search_animation.gif";

import theme from "@theme/index";

function CheckmarkItem({ text }: { text: string }) {
  return (
    <Box
      sx={{
        alignItems: "center",
        display: "flex",
        gap: 1,
      }}
    >
      <VerifiedRoundedIcon color="success" />
      <Typography
        sx={{
          fontWeight: 600,
        }}
      >
        {text}
      </Typography>
    </Box>
  );
}

/**
 * `EmbeddingSearchLoading` component.
 *
 * Used to display a loading state.
 * It makes use of the `SpinnerWithLabel` component to provide an animated loading spinner.
 *
 * This component is intended to be displayed during potentially long-loading processes, such as search operations.
 *
 */
export default function EmbeddingSearchLoading() {
  return (
    <Box
      className="search-progress"
      sx={{
        backgroundColor: theme.palette.common.white,
        borderRadius: 1,
        display: "flex",
        flexGrow: 1,
      }}
    >
      <Container
        maxWidth="sm"
        style={{
          alignItems: "center",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
        }}
      >
        <Box
          alt="smart-search-animation"
          component="img"
          src={SmartSearchAnimation}
          sx={{
            [theme.breakpoints.up("md")]: {
              width: 160,
            },
            [theme.breakpoints.up("sm")]: {
              width: 120,
            },
            width: 96,
          }}
        />
        <Box>
          <Typography
            align="center"
            sx={{
              fontFamily: theme.typography.fontFamily,
            }}
            variant="h4"
          >
            {" "}
            Searching...{" "}
          </Typography>
          <Typography
            sx={{
              mt: 3,
            }}
            variant="h6"
          >
            <strong>We’re identifying the best matches based on:</strong>
          </Typography>
          <Box
            sx={{
              alignItems: "flex-start",
              display: "flex",
              flexDirection: "column",
              gap: 1.5,
              mt: 2,
            }}
          >
            <CheckmarkItem text="Keywords related to your technology" />
            <CheckmarkItem text="Syntax and technical language patterns" />
          </Box>
        </Box>
      </Container>
    </Box>
  );
}
